import React, { useContext, useState } from "react";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";
import AccessDenied from "../components/AccessDenied";

const AddPlayer = () => {
  const {
    user,
    navigate,
    setPending,
    backendURL,
    setAlertMessage,
    token,
    setShowAlert,
    getUser,
    setIsErr,
  } = useContext(PitchContext);

  const [playerData, setPlayerData] = useState({
    name: user.fullname,
    image: null,
    city: "",
    age: "",
    position: "",
    phone: user.phone,
    email: user.email,
    description: "",
    height: "", // New field
    weight: "", // New field
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlayerData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", playerData.name);
    formData.append("city", playerData.city);
    formData.append("age", playerData.age);
    formData.append("position", playerData.position);
    formData.append("phone", playerData.phone);
    formData.append("email", playerData.email);
    formData.append("description", playerData.description);
    formData.append("height", playerData.height); // Append height
    formData.append("weight", playerData.weight); // Append weight

    setPending(true);

    // Note: You're sending JSON here, but you might want to use FormData for consistency
    axios
      .post(backendURL + "player/create", {
        ownerID: user._id,
        fullname: playerData.name,
        city: playerData.city,
        age: playerData.age,
        position: playerData.position,
        phone: playerData.phone,
        email: playerData.email,
        description: playerData.description,
        height: playerData.height, // Add height
        weight: playerData.weight, // Add weight
        image: user.profilePicture,
      })
      .then((response) => {
        if (response.data.success) {
          axios
            .post(backendURL + "user/update-player-profile", {
              userID: user._id,
              playerID: response.data.player._id,
            })
            .then((res) => {
              if (res.data.success) {
                getUser();
                setAlertMessage(response.data.message);
                setIsErr(false);
                setShowAlert(true);
                navigate("/takim-arkadasi-bul");
                setPending(false);
              } else {
                setAlertMessage(response.data.message);
                setIsErr(true);
                setShowAlert(true);
                setPending(false);
              }
            })
            .catch((err) => {
              setPending(false);
              console.log(err);
              setAlertMessage(err.response.data.message);
              setIsErr(true);
              setShowAlert(true);
            });
        } else {
          setAlertMessage(response.data.message);
          setIsErr(true);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        console.log(err);
        setAlertMessage(err.response?.data?.message || "An error occurred");
        setIsErr(true);
        setShowAlert(true);
      });
  };

  if (!token) {
    return <AccessDenied />;
  }

  if (user.playerProfile.isCreated) {
    return <AccessDenied />;
  }

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4">
      <div className="max-w-[1000px] mx-auto bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
          Kendinizi Oyuncular Listesine ekleyin
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">İsim</label>
            <input
              type="text"
              name="name"
              value={playerData.name}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.name ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
              placeholder="Adınızı giriniz"
            />
            {errors.name && (
              <p className="text-red-500 text-sm mt-1">{errors.name}</p>
            )}
          </div>

          {/* City */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Şehir
            </label>
            <input
              type="text"
              name="city"
              value={playerData.city}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.city ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
              placeholder="Şehrinizi giriniz (Afyonkarahisar Dinar)"
            />
            {errors.city && (
              <p className="text-red-500 text-sm mt-1">{errors.city}</p>
            )}
          </div>

          {/* Age */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Yaş</label>
            <input
              type="number"
              name="age"
              value={playerData.age}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.age ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
              placeholder="Yaşınızı giriniz"
            />
            {errors.age && (
              <p className="text-red-500 text-sm mt-1">{errors.age}</p>
            )}
          </div>

          {/* Height */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Boy (cm)
            </label>
            <input
              type="number"
              name="height"
              value={playerData.height}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.height ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
              placeholder="Boyunuzu cm cinsinden giriniz (ör. 175)"
            />
            {errors.height && (
              <p className="text-red-500 text-sm mt-1">{errors.height}</p>
            )}
          </div>

          {/* Weight */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Kilo (kg)
            </label>
            <input
              type="number"
              name="weight"
              value={playerData.weight}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.weight ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
              placeholder="Kilonuzu kg cinsinden giriniz (ör. 70)"
            />
            {errors.weight && (
              <p className="text-red-500 text-sm mt-1">{errors.weight}</p>
            )}
          </div>

          {/* Position */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Pozisyon
            </label>
            <select
              name="position"
              value={playerData.position}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.position ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
            >
              <option value="">Pozisyon seçiniz</option>
              <option value="Forvet">Forvet</option>
              <option value="Ortasaha">Orta Saha</option>
              <option value="Defans">Defans</option>
              <option value="Kaleci">Kaleci</option>
            </select>
            {errors.position && (
              <p className="text-red-500 text-sm mt-1">{errors.position}</p>
            )}
          </div>

          {/* Phone */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Telefon
            </label>
            <input
              type="text"
              name="phone"
              value={playerData.phone}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.phone ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
              placeholder="Telefon numaranızı giriniz"
            />
            {errors.phone && (
              <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
            )}
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={playerData.email}
              onChange={handleChange}
              className={`w-full px-4 py-3 border ${
                errors.email ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300`}
              placeholder="Email adresinizi giriniz"
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Açıklama (isteğe bağlı)
            </label>
            <textarea
              name="description"
              value={playerData.description}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] transition-all duration-300 resize-y"
              placeholder="Kendiniz hakkında kısa bir açıklama giriniz"
              rows="4"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#6ca87e] text-white py-3 rounded-lg hover:bg-[#5b8f6a] transition-colors duration-200 font-semibold cursor-pointer"
          >
            Ekle
          </button>
        </form>

        {/* Cancel Button */}
        <button
          onClick={() => navigate("/")}
          className="w-full mt-4 text-gray-600 py-3 rounded-lg hover:text-gray-800 transition-colors duration-200 cursor-pointer"
        >
          İptal
        </button>
      </div>
    </div>
  );
};

export default AddPlayer;
